export const SHOW_LOADING_DIV = 'SHOW_LOADING_DIV';
export const HIDE_LOADING_DIV = 'HIDE_LOADING_DIV';

export const SHOW_SUCCESS_TOAST = 'SHOW_SUCCESS_TOAST';
export const HIDE_SUCCESS_TOAST = 'HIDE_SUCCESS_TOAST';

export const SHOW_ERROR_TOAST = 'SHOW_ERROR_TOAST';
export const HIDE_ERROR_TOAST = 'HIDE_ERROR_TOAST';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const EDIT_PROFILE = 'EDIT_PROFILE';

export const REFRESH_DATA_SETS = 'REFRESH_DATA_SETS';

export const CHOOSE_PASSWORD = 'CHOOSE_PASSWORD';
export const ENTER_PHONE = 'ENTER_PHONE';
export const NEXT_REGISTRATION_STEP = 'NEXT_REGISTRATION_STEP';
export const PREVIOUS_REGISTRATION_STEP = 'PREVIOUS_REGISTRATION_STEP';
export const FINISH_REGISTRATION = 'FINISH_REGISTRATION';
export const FINISH_REGISTRATION_LEGAL_TEAM = 'FINISH_REGISTRATION_LEGAL_TEAM';
export const OPEN_INVITATION = 'OPEN_INVITATION';
export const INVALID_INVITATION = 'INVALID_INVITATION';
export const ACCEPT_LEGAL_TERMS = 'ACCEPT_LEGAL_TERMS';

export const SET_PASSWORD_RESET_TOKEN = 'SET_PASSWORD_RESET_TOKEN';
export const INVALID_PASSWORD_RESET_TOKEN = 'INVALID_PASSWORD_RESET_TOKEN';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_CANCELLED = 'PASSWORD_RESET_CANCELLED';
